import { addReactError } from '@datadog/browser-rum-react';
import PropTypes from 'prop-types';
import React, { ErrorInfo } from 'react';
import { ErrorView } from './ErrorView';
export interface ErrorProperties {
  error: Error;
  errorInfo: ErrorInfo;
}

interface IProps {
  route: {
    to: string,
    from: string
  }
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<IProps>> {

  /**
   * If an error exists and the routes from previous and current differ, clear errors
   */
  override componentDidUpdate() {
    if (this.state.error && (this.props.route.from !== this.props.route.to)) {
      this.clearState();
    }
  }


  override state = { error: null, errorInfo: null };

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // If Datadog is initialized, log the error
    window.RUNTIME_CONFIG.DATADOG_INITIALIZED && addReactError(error, errorInfo);
  }

  /**
  * On component update, clear error state to allow navigation without refresh
  * @param previousProps previous state
  */

  clearState() {
    this.setState({
      error: null,
      errorInfo: null
    })
  }

  override render() {
    if (this.state.error && this.state.errorInfo) {
      // Error path
      return (
        <ErrorView error={this.state.error!} errorInfo={this.state.errorInfo!} />
      );
    }
    // Normally, just render children
    return this.props.children;
  }

  static get propTypes() {
    return {
      children: PropTypes.any
    }
  }
}

export default ErrorBoundary;
